import { ACTIVITY_TYPES, type ActivityType } from './activities/types'

export { ACTIVITY_TYPES } from './activities/types'

export type CrmRecord = Record<string, unknown>

export const CONTACT_ACTIVITY_TYPES: ActivityType[] = [
  ACTIVITY_TYPES.WHATSAPP_MESSAGE,
  ACTIVITY_TYPES.INSTAGRAM_MESSAGE,
  ACTIVITY_TYPES.FACEBOOK_MESSAGE,
  ACTIVITY_TYPES.EMAIL,
  ACTIVITY_TYPES.PHONE_CALL,
  ACTIVITY_TYPES.IN_PERSON_VISIT,
  ACTIVITY_TYPES.VOICE_NOTE,
]

export const STATUS_LABELS: Record<string, string> = {
  new: 'Nuevo',
  contacted: 'Contactado',
  responded: 'Respondió',
  follow_up: 'Seguimiento',
  meeting_scheduled: 'Reunión agendada',
  proposal_sent: 'Propuesta enviada',
  negotiation: 'Negociación',
  won: 'Ganado',
  lost: 'Perdido',
  not_qualified: 'No calificado',
  future_opportunity: 'Oportunidad futura',
}

export const INTEREST_LABELS: Record<string, string> = {
  cold: 'Frío',
  warm: 'Tibio',
  hot: 'Caliente',
}

export function value(record: CrmRecord, ...keys: string[]) {
  for (const key of keys) {
    const current = record[key]
    if (current !== null && current !== undefined && current !== '') {
      return String(current)
    }
  }
  return ''
}

export function numberValue(record: CrmRecord, ...keys: string[]) {
  for (const key of keys) {
    const current = Number(record[key])
    if (Number.isFinite(current)) return current
  }
  return null
}

export function dateValue(record: CrmRecord, ...keys: string[]) {
  const raw = value(record, ...keys)
  return raw ? new Date(raw) : null
}

export function formatDateTime(raw: string | null | undefined) {
  if (!raw) return '—'
  const date = new Date(raw)
  if (Number.isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat('es-CR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date)
}

export function formatCurrency(amount: number | null, currency = 'CRC') {
  if (amount === null) return 'No disponible'
  return new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount)
}

export function startOfMonthIso() {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), 1).toISOString()
}

export function todayKey() {
  return new Date().toISOString().slice(0, 10)
}

export function normalizeWhatsApp(valueToNormalize: string) {
  const cleaned = valueToNormalize.replace(/[\s-]/g, '').replace(/^\+/, '')
  return /^\d{8}$/.test(cleaned) ? `506${cleaned}` : cleaned
}

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function isValidUuid(valueToValidate: string) {
  return UUID_REGEX.test(valueToValidate)
}

export function prospectId(record: CrmRecord) {
  return value(record, 'prospect_id', 'id')
}

export function safeErrorMessage(code?: string) {
  if (code === '42501') {
    return 'No tenés permisos para realizar esta acción.'
  }
  return 'No fue posible completar la operación. Revisá tu conexión e intentá nuevamente.'
}

export function isAdmin(role: string | null) {
  return role?.toLowerCase() === 'admin'
}
